"use client";

import { cookieService } from "@/lib/cookie/cookieService";
import { routes } from "@/lib/utils/routes";
import { useBusinessInfoStore, useRegistInfoStore } from "@/modules/store";
import { redirect } from "next/navigation";
import { useEffect } from "react";

export default function CheckAuthProvider({
  children,
}: {
  children?: React.ReactNode;
}) {
  const {
    businessInfo,
    getInfoError: err,
    getBusinessInfo,
  } = useBusinessInfoStore();
  const { step, done } = useRegistInfoStore();

  useEffect(() => {
    if (step == 1 && !done) {
      redirect(routes.registerInfo);
    }
    if (businessInfo && businessInfo.id.length > 0) return;
    const businessId = cookieService.get("businessId");
    if (businessId) {
      getBusinessInfo({ businessId });
    } else {
      getBusinessInfo();
    }
  }, []);

  useEffect(() => {
    if (err) {
      if (step == 1 && !done) {
        redirect(routes.registerInfo);
      } else {
        redirect(routes.login);
      }
    }
  }, [err]);

  return <>{children}</>;
}
